<template>

  <t-page>

    <TypeInstrumentDialog :no-option-add="noOptionAdd" @onSubmit="onTypeInstrumentDialog"/>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template #default="{status}">

        <t-input v-model="form.instrumentId" hidden/>

        <b-row>

          <t-input v-model="form.name"  :add-error="error.name" label="Descrição" cols="9" required/>

          <t-input v-model="form.instrumentCodeLabel" v-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_MANUAL"
                   :add-error="error.instrumentCodeLabel" upper cols="3"
                   label="Cód. Instrumento"
                   code-label
                   help="Código inserido manualmente conforme configurado em Produção > Configurações > Parâmetros"
                   required/>

          <t-input v-model="form.instrumentCodeLabel"
                   v-else-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_AUTOMATIC_DEFAULT"
                   :add-error="error.instrumentCodeLabel" upper cols="3"
                   fixed
                   label="Cód. Instrumento"
                   help="Código inserido automaticamente conforme configurado em Produção > Configurações > Parâmetros"
          />



        </b-row>


        <t-input v-model="form.typeInstrumentId"
                 :options="typeInstrumentOptions"
                 required

                 label="Tipo de Instrumento" select>

          <template #no-options="{search}">
            <b-link @click="addNoOption('modal-type-instrument',search)">Cadastrar Tipo</b-link>
          </template>

          <template #input-group-append>
            <t-button title="Adicionar novo Tipo" @click="openDialogForm('modal-type-instrument')"
                      icon-plus/>
          </template>

        </t-input>


        <!--ATENÇÃO NÃO ESQUECER DE UTILIZAR template #default="{status} para funcionamento correto-->
        <t-page-form-field-customized
            ref="fieldsGeneral"
            :command="command" :status="status" :user-auth="userAuth"
            :fields-customizable="entityFieldCustomized('page')"
            :primary-key="form.instrumentId" :foreign-key="currentPage.pageId" :busy="!pageFormIsLoaded"
            :primary-key-column="fieldKey" foreign-key-column="pageId"
        />

        <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

        <t-input-status v-model="form.status"/>

      </template>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import TypeInstrumentDialog from "@/views/modules/production/Type/TypeInstrumentDialog";
import typeInstrumentService from "@/services/modules/production/TypeInstrument.service";
import SettingType from "@/model/types/resource/SettingType";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  components: {TypeInstrumentDialog},
  name: 'InstrumentForm',
  data() {
    return {
      SettingType,
      path: "", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: true,
      fieldKey: "instrumentId",
      form: {
        instrumentId: 0,
        instrumentCodeLabel: "",
        typeInstrumentId: 0,
        note: "",
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        instrumentCodeLabel: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      modeCodeLabel: "",
      noOptionAdd: "", //Usado para armazenar o começo do nome digitado para inserção rápida em dialogos na página.
      typeInstrumentOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      this.modeCodeLabel = this.getRenderRule(SettingType.render.RENDER_TAG_COD_LABEL)

      await typeInstrumentService.selectList("").then((list) => {
        this.typeInstrumentOptions = list
      }).catch(error => this.responseError(error))

      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    onTypeInstrumentDialog(itemInserted) {
      
      this.form.typeInstrumentId = itemInserted.value
      this.typeInstrumentOptions.push(itemInserted); //Simples, pois é uma lista não agrupada

    },

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  }

}
</script>
